<template>
  <Dialog :buttons="buttons">
    <div class="voice-disclaimer-container">
      <span>{{ Locale.i18n.t('page.voice.disclaimer') }}</span>
      <span v-if="showDisclaimer" class="voice-disclaimer-warning">{{
        Locale.i18n.t('page.voice.disclaimer_warning')
      }}</span>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Dialog, { ButtonType } from '@/components/Dialog.vue';
import * as Locale from '@/plugins/i18n';
import { platform } from '@/common/bridge';

interface Props {
  buttons?: ButtonType[];
}

withDefaults(defineProps<Props>(), {
  buttons: () => [],
});

const showDisclaimer = computed(() => {
  return platform !== 'web';
});
</script>

<style lang="scss" scoped>
.voice-disclaimer-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.voice-disclaimer-warning {
  font-weight: bold;
}
</style>
